import { createContext } from 'react';

export interface State {
  scale: number;
  baseWidth: number;
  maxSlide: number;
  nextSlide: number;
  backTop: boolean; // 是否执行了backTop操作
}

interface Action {
  type?: string;
  load?: Partial<State>;
}
export const reducerIntialState: State = {
  scale: 3840 / 2000,
  baseWidth: 1920,
  maxSlide: 15,
  nextSlide: 0,
  backTop: false,
};

export const reducer = (prevState: State, action: Action) => {
  let newState = { ...prevState };
  switch (action.type) {
    case 'backtop':
      newState.nextSlide = 0;
      newState.backTop = true;
      return newState;
    default:
      newState = { ...prevState, ...action.load };
      return newState;
  }
};

const HomeContext = createContext({});
export default HomeContext;
